<template>
    <div class="Hiesidresponden">
        <v-snackbar
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        v-model="snackbar.show"
        >
        {{ snackbar.message }}
        </v-snackbar>
        <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="item">
            <v-breadcrumbs-item
                slot="items"
                slot-scope="{ items }"
                exact
                :to="items.to"
                :disabled="items.disabled"
            >
                {{ items.text }}
            </v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                {{ $t("maklumatresponden") }}
            </v-card-title>
            <v-container>
                <v-form ref="formtapisanresponden">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-autocomplete
                            outlined
                            dense
                            v-bind:label="$t('negeri')"
                            :items="lookupnegeri"
                            item-text="negeri"
                            item-value="negeriID"
                            v-model="paparnegeriexport"
                            :disabled="disablenegeri"
                            v-on:change="paparbtnexport"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-select
                            :items="lookuppusingan"
                            outlined
                            dense
                            return-object
                            v-model="caripusingan"
                            v-bind:label="$t('pusingan')"
                            item-text="pusingan"
                            v-on:change="paparbtnexport"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                        v-model="caridatajr2"
                        outlined
                        dense
                        v-bind:label="$t('cari')"
                        class="mx-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-col class="text-right">
                            <v-btn type="button" v-show="btnexportstatus" @click="exportmaklumatresponden()" color="blue white white--text">
                                <span class="material-icons">file_download</span>
                                {{ $t("muatturun") }} {{ $t("maklumatresponden") }}V2
                            </v-btn>
                        </v-col>
                    
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-col class="text-right">
                        <v-btn color="green white--text" @click="caridatajr2responden"
                            ><span class="material-icons">search</span
                            >{{ $t("cari") }}</v-btn
                        >
                        </v-col
                        >
                    </v-col>
               </v-row>
                </v-form>
                <v-data-table
                    :headers="headers"
                    :items="datajr2responden"
                    :search="caridatajr2"
                    :items-per-page="100"
                    class="elevation-1"
                >
                </v-data-table>
            </v-container>
        </v-card>
         </v-card>
    </div>
</template>
<script>
import i18n from "@/i18n";
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import axios from "../../plugins/axios";
export default {
    Name: "Hiesidresponden",
    setup() {},
    computed: {},
    data: () => ({
        btnexportstatus: false,
        tokenexport: window.localStorage.getItem('tokenexport'),
        caridatajr2:"",
        snackbar: "",
        lookuppusingan: [],
        lookupnegeri: [],
        caripusingan: "",
        paparnegeriexport: "",
        disablenegeri: false,
        datajr2responden: [],
        required(text) {
            return (v) =>
                (v && v.length > 0) || `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
        },
        item: [
            {
                text: i18n.t("utama"),
                disabled: false,
                href: "paparanutama",
            },
            {
                text: i18n.t("maklumatresponden"),
                disabled: true,
                href: "",
            },
        ],
        headers: [
            { text: i18n.t("bil"), value: "Bil" },
            { text: i18n.t("hid"), value: "HID" },
            { text: i18n.t("notac"), value: "HIESID" },
            { text: i18n.t("emel"), value: "Email" },
            { text: i18n.t("negeri"), value: "NG" },
            { text: i18n.t("nama"), value: "Pengguna" },

        ],
    }),
    mounted() {
        this.permulaan()
        this.$store.dispatch("localStorageuser");
    },
    methods: {
        async paparbtnexport(){
            let btnenable = 0
            if(this.paparnegeriexport !== '20' && this.paparnegeriexport !== '' ){
                btnenable ++
            }
            if(this.caripusingan !== '' ){
                btnenable ++
            }
            if(btnenable === 2){
                this.btnexportstatus = true
            }
        },
        async exportmaklumatresponden(){
            try {
                await axios
                .post(
                    `${process.env.VUE_APP_API_URL}/sec/checksession`,
                    {
                        tokenexportsess: window.localStorage.getItem('tokenexport')
                    }
                )
                .then(result=>{
                    console.log(result.data.status)
                    if(result.data.status){
                    window.open(`${process.env.VUE_APP_API_URL}/JR/exporthiesidserverside/${this.tokenexport}/${this.caripusingan.tahun}/${this.caripusingan.bulan}/${this.caripusingan.pusingan}/${this.paparnegeriexport}/`, '_blank');
                    }
                })
            } catch (error) {
                console.log(error)
            }
        },
        async permulaan(){
            // this.peranan = this.$store.state.localStorageuser.role;
            this.peranan = JSON.parse(window.localStorage.getItem('user'))
            console.log(this.peranan.role)
            let res = await pusingan.getPusinganData();
            this.lookuppusingan = res.data.data;
            let negeri = await negerilookup.getNegeri();
            let role = ["PP", "PO", "FE", "RESPONDENT"]
            this.disablenegeri =
            role.includes(this.peranan.role) === true
                ? true
                : false;
            this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
            const Negeri = [];
            negeri.data.data.forEach(async function (element) {
                if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
                Negeri.push({
                    negeriID: `${element.negeriID}`,
                    negeri: `${element.negeri}`,
                });
                }
            });
            this.lookupnegeri = Negeri
        },
        async caridatajr2responden(){
            try{
                if(this.caripusingan !== ''){
                    try{
                        let datajr2responden = {
                            bulan: this.caripusingan.bulan,
                            tahun: this.caripusingan.tahun,
                            pusingan: this.caripusingan.pusingan,
                            negeri: this.paparnegeriexport
                        }
                        await axios
                        .post(
                            `${process.env.VUE_APP_API_URL}/JR/paparjr2hiesid`,
                            datajr2responden
                        ).then(result=>{
                            console.log(result.data)
                            this.datajr2responden = result.data.datajr2
                        })
                    }catch(err){
                        console.log(err)
                    }
                } else {
                    this.snackbar = {
                    message: 'Isi Pusingan',
                    timeout: 2000,
                    color: "red darken-4",
                    show: true,
                    };
                }
            }catch(err){
                console.log(err)
            }
        },
    },
}
</script>